(function haThaSlider() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'ha_slider-article';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }
  $(() => {
    $('.slider-article-slick').slick({
      autoplay: false,
      autoplaySpeed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow:
        '<button class="slick-prev show-for-large" type="button"><span class="i-arrow-left-circle"></span><span class="slick-sr-only">Slide précédente</span></button>',
      nextArrow:
        '<button class="slick-next show-for-large" type="button"><span class="i-arrow-right-circle"></span><span class="slick-sr-only">Slide suivante</span></button>',
      dots: true,
      arrows: true,
      customPaging: (slider, i) =>
        $(
          `<button type="button"><span class="slick-dot-icon" aria-hidden="true"></span><span class="slick-sr-only">Aller vers la slide ${
            i + 1
          }</span></button>`,
        ),
    });
  });
})();
